/**
 * Preview message component (main message renderer)
 */

'use client';

import { useMemo, useState } from 'react';
import type { ChatMessage } from '@/lib/types';
import { cn } from '@/lib/utils';
import { MessagePart } from './MessagePart';
import type { MessageMode } from './types';

type PreviewMessageProps = {
  message: ChatMessage;
  isLoading: boolean;
};

export function PreviewMessage({
  message,
}: PreviewMessageProps) {
  const [mode] = useState<MessageMode>('view');

  const isUser = message.role === 'user';

  const sortedParts = useMemo(() => {
    const parts = message.parts ?? [];
    const textParts = parts.filter(
      (p: { type?: string }) => p.type === 'text',
    );
    const toolParts = parts.filter((p: { type?: string }) =>
      p.type?.startsWith('tool-'),
    );
    return [...textParts, ...toolParts];
  }, [message.parts]);

  return (
    <div
      className={cn(
        'mb-2 flex w-full',
        isUser ? 'justify-end' : 'justify-start',
      )}
    >
      <div className="w-full flex flex-col gap-2">
        {sortedParts.map((part, index) => (
          <MessagePart
            key={`${message.id}-${index}`}
            part={part}
            index={index}
            messageId={message.id}
            mode={mode}
            role={message.role as 'user' | 'assistant'}
          />
        ))}
      </div>
    </div>
  );
}
